export enum PricingSpecsTableAction {
  ADD_PRICING_SPEC_IN_LENDER_CONTEXT = 'ADD_PRICING_SPEC_IN_LENDER_CONTEXT',
  REMOVE_PRICING_SPEC_IN_LENDER_CONTEXT = 'REMOVE_PRICING_SPEC_IN_LENDER_CONTEXT',
  REMOVE_PRICING_SPEC_FROM_PRICING = 'REMOVE_PRICING_SPEC_FROM_PRICING',
}
